import { useState, useRef, useEffect } from 'react'
import { DataTable } from './DataTable'
import { Form, Upload, Image } from 'antd'
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhBox } from '@/components/YhBox'
import { YHRightModal } from "@/components/YHRightModal";
import { YhForm } from "@/components/YhFormBox";
import { totalModel } from './totalModel'
import debounce from 'lodash/debounce';
import FontIcon from "@/components/YhIcon";

export const DataBox2 = () => {

    const {
        mode, setMode,
        visible, setVisible,
        formInfo, setFormInfo,
        getOne, uploadFileList,
        selectedRowKeys,
    } = totalModel()

    const formRef = useRef<IYhFormRef>();
    const [form] = Form.useForm();

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    useEffect(() => {
        if (visible) {
            getOne(selectedRowKeys[0]);
        }
    }, [visible])

    const action = (
        <>
        </>
    )

    const onChange = (changedValues: { [key: string]: any }) => {
        setFormInfo({ ...formInfo, ...changedValues });
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        formValues: formInfo,
        onChange: debounce(onChange, 500),
        items: [
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '结算账单信息',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item>
                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>结算账单信息</span>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单编号",
                fieldName: "code",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "加盟商名称",
                fieldName: "partnerName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单数量",
                fieldName: "num",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单金额",
                fieldName: "billAmount",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '账单发票信息',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item>
                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>账单发票信息</span>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票号码",
                fieldName: "invoiceNum",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票日期",
                fieldName: "invoiceTime",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "开票单位",
                fieldName: "customerName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收票单位",
                fieldName: "supplierName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "税率",
                fieldName: "invoiceTax",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票金额",
                fieldName: "invoiceAmount",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票备注",
                fieldName: "invoiceNote",
                span: 12,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运维审核意见",
                fieldName: "auditAdvise",
                labelCol: { span: 3 },
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "审核意见",
                fieldName: "fmsAuditAdvise",
                labelCol: { span: 3 },
                span: 24,
                disable: mode == 'examine' ? false : true
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "发票",
                fieldName: "file",
                span: 24,
                formItem: (
                    <Form.Item
                        name="fileList"
                        labelCol={{ span: 3 }}
                        label="附件">
                        <Upload
                            name="file"
                            disabled={true}
                            fileList={uploadFileList}
                            iconRender={(file) => {
                                if (file?.type?.indexOf('image') !== -1) return <><Image style={{ width: 24 }} src={file.thumbUrl} /></>
                                if (file?.type?.indexOf('pdf') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                                if (file?.type?.indexOf('msword') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-doc" />
                            }}
                            onPreview={(file) => {
                                if (file?.type?.indexOf("pdf") != -1 || file?.type?.indexOf("doc") != -1) {
                                    window.location.href = file?.url ?? "";
                                }
                                else {
                                    setPreviewImage(file?.url ?? "");
                                    setPreviewOpen(true);
                                }
                            }}
                        >
                        </Upload>
                    </Form.Item >
                ),
            },
        ]
    };


    return (

        <>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>

            <YHRightModal
                visible={visible}
                onOk={() => setVisible(false)}
                onCancel={() => { setVisible(false); }}
                title="详情"
                width={800}
                showFooter={false}
            >
                <div style={{ padding: 10 }}>
                    <Form form={form} component={false}>
                        <YhForm formRef={formRef} {...formConfig} />
                    </Form>
                </div>
            </YHRightModal>

            <Image
                width={200}
                style={{ display: 'none' }}
                src={previewImage}
                preview={{
                    visible: previewOpen,
                    //src: previewImage,
                    onVisibleChange: value => {
                        setPreviewOpen(value);
                    },
                }}
            />
        </>
    )
}
